import * as actionTypes from './actionTypes';
import { AttributeValueActionTypes } from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import { AttributeValue } from '../../domain/AttributeValue';

export type AttributeValueStateType = {
  setAttributeValueLoading: boolean;
  setAttributeValueError: HttpError;
  setAttributeValueSuccess: boolean;
  updatedAttributeValue: AttributeValue | null;
  attributeValueUpdateLoading: boolean;
  attributeValueUpdateError: HttpError;
  attributeValueUpdateSuccess: boolean;
  attributeValueDeleteLoading: boolean;
  attributeValueDeleteError: HttpError;
  attributeValueDeleteSuccess: boolean;
};

export type AttributeValueActionType = AttributeValueStateType & {
  type: AttributeValueActionTypes;
};

export const initialState: AttributeValueStateType = {
  setAttributeValueLoading: false,
  updatedAttributeValue: null,
  setAttributeValueError: null,
  setAttributeValueSuccess: false,
  attributeValueUpdateError: null,
  attributeValueUpdateLoading: false,
  attributeValueUpdateSuccess: false,
  attributeValueDeleteLoading: false,
  attributeValueDeleteError: null,
  attributeValueDeleteSuccess: false,
};

const setAttributeValueStart = (
  state: AttributeValueStateType,
): AttributeValueStateType => ({
  ...state,
  setAttributeValueLoading: true,
});

const setAttributeValueSuccess = (
  state: AttributeValueStateType,
  action: AttributeValueActionType,
): AttributeValueStateType => ({
  ...state,
  setAttributeValueLoading: false,
  setAttributeValueError: null,
  setAttributeValueSuccess: true,
  updatedAttributeValue: action.updatedAttributeValue,
});

const setAttributeValueFail = (
  state: AttributeValueStateType,
  action: AttributeValueActionType,
): AttributeValueStateType => ({
  ...state,
  setAttributeValueLoading: false,
  setAttributeValueError: action.setAttributeValueError,
});

const updateAttributeValueStart = (
  state: AttributeValueStateType,
): AttributeValueStateType => ({
  ...state,
  attributeValueUpdateLoading: true,
});

const updateAttributeValueSuccess = (
  state: AttributeValueStateType,
): AttributeValueStateType => ({
  ...state,
  attributeValueUpdateLoading: false,
  attributeValueUpdateError: null,
  attributeValueUpdateSuccess: true,
});

const updateAttributeValueFail = (
  state: AttributeValueStateType,
  action: AttributeValueActionType,
): AttributeValueStateType => ({
  ...state,
  attributeValueUpdateLoading: false,
  attributeValueUpdateError: action.attributeValueUpdateError,
});

const deleteAttributeValueStart = (
  state: AttributeValueStateType,
): AttributeValueStateType => ({
  ...state,
  attributeValueDeleteLoading: true,
});

const deleteAttributeValueSuccess = (
  state: AttributeValueStateType,
): AttributeValueStateType => ({
  ...state,
  attributeValueDeleteLoading: false,
  attributeValueDeleteError: null,
  attributeValueDeleteSuccess: true,
});

const deleteAttributeValueFail = (
  state: AttributeValueStateType,
  action: AttributeValueActionType,
): AttributeValueStateType => ({
  ...state,
  attributeValueDeleteError: action.attributeValueDeleteError,
  attributeValueDeleteLoading: false,
});

const resetStore = () => ({
  ...initialState,
});

const reducer = (state = initialState, action: AttributeValueActionType) => {
  switch (action.type) {
    case actionTypes.SET_ATTRIBUTE_VALUE_START:
      return setAttributeValueStart(state);
    case actionTypes.SET_ATTRIBUTE_VALUE_SUCCESS:
      return setAttributeValueSuccess(state, action);
    case actionTypes.SET_ATTRIBUTE_VALUE_FAIL:
      return setAttributeValueFail(state, action);
    case actionTypes.UPDATE_ATTRIBUTE_VALUE_START:
      return updateAttributeValueStart(state);
    case actionTypes.UPDATE_ATTRIBUTE_VALUE_SUCCESS:
      return updateAttributeValueSuccess(state);
    case actionTypes.UPDATE_ATTRIBUTE_VALUE_FAIL:
      return updateAttributeValueFail(state, action);
    case actionTypes.DELETE_ATTRIBUTE_VALUE_START:
      return deleteAttributeValueStart(state);
    case actionTypes.DELETE_ATTRIBUTE_VALUE_SUCCESS:
      return deleteAttributeValueSuccess(state);
    case actionTypes.DELETE_ATTRIBUTE_VALUE_FAIL:
      return deleteAttributeValueFail(state, action);
    case actionTypes.RESET_ATTRIBUTE_VALUE_STORE:
      return resetStore();
    default:
      return state;
  }
};

export default reducer;
